import React from 'react';

const PlazoIcon = () => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="54" height="68" fill="none" viewBox="0 0 54 68">
      <path fill="#27D0AF" d="M42.282 12.784v-8.54h4.752V1.36H6.912v2.883h4.752v8.54c0 3.482 1.674 6.692 4.536 8.705l8.316 5.712-8.316 5.766a10.652 10.652 0 0 0-4.536 8.704v8.541H6.912v2.883h40.122v-2.883h-4.752v-8.595c0-3.482-1.674-6.691-4.536-8.704L29.484 27.2l8.316-5.767c2.808-1.958 4.482-5.222 4.482-8.65zm-27.756 0v-8.54H39.42v8.54c0 2.285-1.026 4.406-2.7 5.875H17.28c-1.728-1.469-2.754-3.59-2.754-5.875zM36.18 35.306c2.052 1.414 3.294 3.808 3.294 6.31v7.398L28.89 38.352c-1.026-1.034-2.754-1.034-3.834 0l-10.53 10.662v-7.398c0-2.502 1.242-4.896 3.294-6.31L27 28.94l9.18 6.365z"/>
    </svg>
  );
}

export default PlazoIcon;
